const deepEqual = require('fast-deep-equal');
export function shallowEqualObjects(objA, objB) {
    if (objA === objB) {
        return true;
    }
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (let i = 0; i < len; i++) {
        const key = aKeys[i];
        if (objA[key] !== objB[key]) {
            return false;
        }
    }
    return true;
}
export function equalCapturedMetrics(objA, objB) {
    if (objA.eventDetails && !objB.eventDetails) {
        return false;
    }
    if (!objA.eventDetails && objB.eventDetails) {
        return false;
    }
    if (!objA.eventDetails && !objB.eventDetails) {
        return shallowEqualObjects(objA, objB);
    }
    if (objA.eventDetails && objB.eventDetails) {
        return deepEqual(objA, objB);
    }
}
